import React, { Component } from 'react';

import { FormContainer } from 'shared/components/Form';
import { INSPECTIONS } from 'shared/helpers/constants/inspections/inspectionConstants';
import { inspectionTypes } from 'shared/helpers/constants/inspections/inspectionTypes';
import { scheduleLotInspection } from 'shared/helpers/constants/modalConstants';
import { snackbarOptions } from 'shared/helpers/matchers/snackbar/snackbarOptions';

import { LotInspectionsForm } from '../LotInspectionsForm/LotInspectionsForm';

class ScheduleLotInspectionBase extends Component {
  submit = values => {
    this.props.openModal(scheduleLotInspection, () =>
      this.props.scheduleLotInspection(values).then(this.resolveAction).catch(this.resolveAction),
    );
  };

  resolveAction = result => {
    this.props.showSnackbar(snackbarOptions(result.messageType), result.message);
    this.props.history.push('/lots/outgoing');
  };

  render() {
    const {
      modal,
      closeModal,
      openModal,
      getLotsForInspection,
      assignedLots,
      clearAssignedLotsAction,
    } = this.props;
    const { isPending } = this.props.lotInspections;

    return (
      <FormContainer header={INSPECTIONS.SCHEDULE_LOT_INSPECTION} loaded={!isPending}>
        {() => (
          <LotInspectionsForm
            modal={modal}
            openModal={openModal}
            closeModal={closeModal}
            onSubmit={this.submit}
            assignedLots={assignedLots}
            getLotsForInspection={getLotsForInspection}
            clearAssignedLotsAction={clearAssignedLotsAction}
            inspectionType={inspectionTypes.schedule}
          />
        )}
      </FormContainer>
    );
  }
}

export { ScheduleLotInspectionBase };
